module.exports = __webpack_public_path__ + "static/media/25sqm.2076fe86.JPG";